import React from 'react';
import Event from './Event';

const EventContainer = ({ event }: { event: Timeline.Event }) => {
  return <Event event={event} />;
};

export default EventContainer;
